/**
 * @generated SignedSource<<27dc2d77bade3b88149aa237041448f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTeamsRoutingInput = {
  storeIds?: ReadonlyArray<string> | null;
  teamIds: ReadonlyArray<string>;
};
export type OrgAdminTopicsEditMutation$variables = {
  description: string;
  name: string;
  receivers?: SetTeamsRoutingInput | null;
  topicId: string;
};
export type OrgAdminTopicsEditMutation$data = {
  readonly organisation: {
    readonly topic: {
      readonly setDescription: {
        readonly description: string | null;
        readonly id: string;
        readonly name: string;
      };
      readonly setReceivers: {
        readonly allReceiverStores: ReadonlyArray<{
          readonly store: {
            readonly id: string;
          };
        }>;
        readonly teams: ReadonlyArray<{
          readonly id: string;
        }> | null;
      } | null;
    };
  };
};
export type OrgAdminTopicsEditMutation = {
  response: OrgAdminTopicsEditMutation$data;
  variables: OrgAdminTopicsEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "receivers"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "topicId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "receivers"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "setDescription",
      "variableName": "description"
    },
    {
      "kind": "Variable",
      "name": "setName",
      "variableName": "name"
    }
  ],
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "setDescription",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsEditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "TopicMutation",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "setReceivers",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReceiverStore",
                    "kind": "LinkedField",
                    "name": "allReceiverStores",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgAdminTopicsEditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "TopicMutation",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "setReceivers",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReceiverStore",
                    "kind": "LinkedField",
                    "name": "allReceiverStores",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57a1088d1494e4b14b41d9725df698ec",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsEditMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminTopicsEditMutation(\n  $topicId: ID!\n  $name: String!\n  $description: String!\n  $receivers: SetTeamsRoutingInput\n) {\n  organisation {\n    topic(id: $topicId) {\n      setReceivers(input: $receivers) {\n        teams {\n          id\n        }\n        allReceiverStores {\n          store {\n            id\n          }\n          id\n        }\n        id\n      }\n      setDescription(setDescription: $description, setName: $name) {\n        id\n        description\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a0bb7b00ae0e8afaf1227904506d28c";

export default node;
